export const FREQUENT_FLYER_TITLE = "Frequent flyer details";
export const ADDITIONAL_INFO_TITLE = "Additional information";
export const ADULT_TITLE = "Adult";
export const CHILD_TITLE = "Child";
export const INFANT_SEAT_TITLE = "Infant";
export const INFANT_LAP_TITLE = "Infant";
export const UPDATE_TEXT = "Updating passengers";
export const VALIDATE_TEXT = "Validating passengers";
export const ADD_TRAVELER_INFO_TEXT = "Add driver information";
export const ADD_TRAVELERS_TEXT = "Add primary driver";
export const ADD_TRAVELERS_TEXT_UPDATED = "Select or add driver";
export const ADD_TRAVELER_ERROR_MESSAGE =
  "Add or choose one driver to continue.";
export const TRAVELER_INFORMATION_TITLE = "Add driver";
export const COMPLETE_PROFILE_TITLE = "Complete driver profile";
export const COMPLETE_PROFILE_SUBTITLE =
  "Please make sure all the information added matches the government issued ID for this Driver as this will be applied to travel bookings moving forward. Driver information will be accessible to all Admins.";
export const EDIT_TRAVELER_TITLE = "Edit driver profile";
export const EDIT_TRAVELER_SUBTITLE =
  "Please make sure all the information added matches the government issued ID for this Driver as this will be applied to travel bookings moving forward.";
